module.exports = __webpack_public_path__ + "img/diningIcon.20ae0f66.svg";